// FirearmSpecific constants - matching backend FirearmSpecificConstants.cs
// These identify specific firearm models/variants that require special handling

export const FirearmSpecificConstants = {
    BLACK_POWDER_RIFLE: '8c40f7a8-2fe2-43fd-9e05-2e9d53105b52',
    BLACK_POWDER_HANDGUN: '6ed09898-6564-4c40-945d-b21e8938e756',
    BLACK_POWDER_FIREARM: 'e9456ee5-1d23-45c1-9ce3-56c96085c239',
    AIR_PISTOL: '8173a5cf-e8b1-4abf-8c7b-683335165270',
    AIR_RIFLE: 'c9eebc4c-be82-4a1c-98ea-ebacb11dec87',
};
